import { render } from "./DataCaptureModal.vue?vue&type=template&id=7b6861c7&scoped=true&ts=true"
import script from "./DataCaptureModal.vue?vue&type=script&lang=ts"
export * from "./DataCaptureModal.vue?vue&type=script&lang=ts"

import "./DataCaptureModal.vue?vue&type=style&index=0&id=7b6861c7&lang=scss&scoped=true"

import exportComponent from "C:\\BuildAgent\\work\\e394cd1ec4c7054f\\src\\TicketSolutions.Personalisation.Client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b6861c7"]])

export default __exports__